import { useCallback } from 'react';
import { useDashboardExperiments } from '../useDashboardExperiments';
export const useHomeExperiments = (recommendations, helpRecommendations) => {
    const { isVariant1, isVariant2, isVariant3, isControl } = useDashboardExperiments();
    const filterList = useCallback((list) => {
        if (!list)
            return [];
        const result = [...list];
        const hideRecommendation = (id) => {
            const index = result.findIndex((rec) => rec.id === id);
            if (index !== -1) {
                result.splice(index, 1);
            }
        };
        switch (true) {
            case isVariant1:
                hideRecommendation('creatorChallenge');
                hideRecommendation('launchStrategy');
                hideRecommendation('joinDiscord');
                break;
            case isVariant2:
                hideRecommendation('launchStrategy');
                hideRecommendation('integrations');
                break;
            case isControl:
                hideRecommendation('creatorChallenge');
                break;
            case isVariant3:
                break;
            default:
                hideRecommendation('creatorChallenge');
                break;
        }
        return result;
    }, [isControl, isVariant1, isVariant2, isVariant3]);
    return {
        recommendationsFiltered: filterList(recommendations),
        helpRecommendationsFiltered: filterList(helpRecommendations),
    };
};
